import React from 'react';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {useTheme} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';
import BottomExpandableDrawer from '../BottomExpandableDrawer';
import {CloseIcon} from '../../../utils/SvgIcons';

const FaceIdNotRecognized = ({visible, onClose}) => {
  const {colors} = useTheme();
  return (
    <BottomExpandableDrawer
      testID={tID('FaceIdNotRecognized-Modal-BottomExpandableDrawer')}
      visible={visible}
      showRipple
      rippleColor={colors.dangerMuted}
      rippleIcon={<CloseIcon />}
      title="Face ID Not Recognized"
      subtitle="Please use your credentials to login or wait an hour before trying again."
      onClose={onClose}
      buttons={[
        {
          title: 'Cancel',
          buttonType: BUTTON_TYPES.Bordered,
          onPress: onClose,
        },
      ]}
    />
  );
};

export default FaceIdNotRecognized;
